import { render } from "./ReactivateTeam.vue?vue&type=template&id=2f655d39"
import script from "./ReactivateTeam.vue?vue&type=script&lang=js"
export * from "./ReactivateTeam.vue?vue&type=script&lang=js"
script.render = render

export default script